import MicroModal from 'micromodal';

const selectors = {
  ageGate: '[data-age-gate]',
  loader: '.cloak-loader',
  underageButton: '[data-underage-button]',
  confirmButton: '[data-overage-button]',
};

const redirectTo = 'https://www.google.com/';

const handleUnderageClick = () => {
  window.location = redirectTo;
};

const handleConfirmClick = () => {
  window.localStorage.setItem('wyldAgeConfirmation', 'true');
  MicroModal.close('age-gate');
};

const openAgeGate = () => {
  const ageGate = document.querySelector(selectors.ageGate);
  const underageButton = ageGate.querySelector(selectors.underageButton);
  const confirmButton = ageGate.querySelector(selectors.confirmButton);
  
  MicroModal.init();

  MicroModal.show('age-gate');
  underageButton.addEventListener('click', handleUnderageClick);
  confirmButton.addEventListener('click', handleConfirmClick);
}

const handleAgeGate = () => {
  const ageGate = document.querySelector(selectors.ageGate);

  if (!ageGate) return;

  const ageConfirmation = window.localStorage.getItem('wyldAgeConfirmation');
  if (ageConfirmation !== 'true') {
    openAgeGate();
  }
};

const init = () => {
  const loader = document.querySelector(selectors.loader);
  const config = { attributes: true, childList: false, subtree: false };
  
  // Callback function to execute when mutations are observed
  const callback = function(mutationsList, observer) {
    // Use traditional 'for loops' for IE 11
    for(const mutation of mutationsList) {
      if (mutation.type === 'attributes') {
        if (loader.classList.contains('gone')) {
          setTimeout(() => {
            handleAgeGate();
          }, 1200);
        }
      }
    }
  };
    // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(loader, config);

  // Later, you can stop observing
  //observer.disconnect();

};

init();